import { useQueryClient } from "@tanstack/react-query"
import { useRealtimeEvent } from "@/contexts/RealtimeContext"

export const useFollowRealtime = (): void => {
  const queryClient = useQueryClient()

  useRealtimeEvent("follow:changed", () => {
    void queryClient.invalidateQueries({ queryKey: ["followers"] })
    void queryClient.invalidateQueries({ queryKey: ["following"] })
    void queryClient.invalidateQueries({ queryKey: ["follow-status"] })
    void queryClient.invalidateQueries({ queryKey: ["pending-requests"] })
    void queryClient.invalidateQueries({ queryKey: ["profileStatistics"] })
    void queryClient.invalidateQueries({ queryKey: ["publicProfileStatistics"] })
    void queryClient.invalidateQueries({ queryKey: ["profile"] })
    void queryClient.invalidateQueries({ queryKey: ["community-members"] })
  })
}
